import React from "react";
import styled from "styled-components";
import { InputTypeAhead } from "@loanbossinc/component-library";
import {
  Card,
  FormControl,
  FormLabel,
  InputLabel,
  Typography
} from "@material-ui/core";

import { assigneeComparison } from "../lenderReportingDashboard.helper";

const SelectWrapper = styled.div`
  margin-top: 15px;
`;

const StyledInputLabel = styled(InputLabel)`
  font-size: 10px;
  margin-left: 40px;
  margin-top: 48px;
`;

const StyledInputTypeAhead = styled(InputTypeAhead)`
  border-radius: 5px;
  overflow: hidden;
  width: 93%;
`;

const StyledSelectCard = styled(Card)`
  margin: 7px 10px;
  outline: 1px solid #dadce0;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-top: 20px;
  width: auto;
  z-index: 1;
`;

const StyledSelectFormLabel = styled(FormLabel)`
  && {
    color: #5f6368;
    margin-top: 30px;
    text-transform: uppercase;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }
`;

const StyledTypography = styled(Typography)`
  color: #5f6368;
  font-size: 12px;
`;

const FilterDrawerTaskAssigneeDropdown = props => {
  const { taskAssignees, copyFilterState, updateFilterState } = props;
  const { taskAssigneeId } = copyFilterState;
  const selectedOption = taskAssignees.find(ta => ta.id === taskAssigneeId);
  const sortedAssignees = taskAssignees.sort(assigneeComparison);

  return (
    <FormControl>
      <StyledSelectCard>
        <StyledSelectFormLabel>Task Assignee</StyledSelectFormLabel>
        <SelectWrapper>
          <StyledInputLabel>
            <StyledTypography>Task Assignee</StyledTypography>
          </StyledInputLabel>
          <StyledInputTypeAhead
            displayWith={option => option && option.name}
            options={sortedAssignees}
            setValueWith={option => option && option.id}
            value={selectedOption}
            onChange={id => updateFilterState("taskAssigneeId", id)}
            variant="filled"
          />
        </SelectWrapper>
      </StyledSelectCard>
    </FormControl>
  );
};

export default FilterDrawerTaskAssigneeDropdown;
